import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { getStoredTheme } from '@/utils/theme';

Vue.use(Vuetify);

const storedTheme = getStoredTheme();

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        dark: storedTheme !== 'light',
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#1D4ED8',
                secondary: '#0F766E',
                accent: '#087E8B',
                error: '#D62F4B',
                info: '#0284C7',
                warning: '#D97706',
                success: '#087A55',
                background: '#EEF3F9',
                surface: '#FFFFFF',
                surfaceMuted: '#F5F8FC',
                border: '#D8E1ED',
                textPrimary: '#142033',
                textSecondary: '#5D6B7E',
            },
            dark: {
                primary: '#60A5FA',
                secondary: '#2DD4BF',
                accent: '#22D3EE',
                error: '#FB7185',
                info: '#38BDF8',
                warning: '#FBBF24',
                success: '#34D399',
                background: '#07111F',
                surface: '#0D1B2D',
                surfaceMuted: '#122238',
                border: '#26384E',
                textPrimary: '#E5EDF8',
                textSecondary: '#93A4BA',
            },
        },
    },
});
